export default ({ id = "", handle = "", title = "" }) => ({
	handle,
	title,

	init() {
		let form = this.$el.querySelector('form')

		form.addEventListener('onAfterFormieSubmit', e => this.trackEvents(e, this.title))

		// refetch the CSRF
		let csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

		fetch(`/actions/formie/forms/refresh-tokens?form=${this.handle}`)
			.then(result => { return result.json(); })
			.then(result => { csrfInput.outerHTML = result.csrf.input; });
	},

	trackEvents(e, title) {
		e.preventDefault();

		console.log('tracking submit event')

		if (e.detail.nextPageId) {
			return;
		}

		let handle = title.toLocaleLowerCase().trim().replaceAll(" ", "_")

		gtag('event', `form_submission_${handle}`, {
  			'form_name': title,
		});
	}
})
